import React, { useState, useEffect, useRef } from "react";

// Mermaid se carga desde CDN para evitar conflictos de webpack con CRA
const MERMAID_CDN = "https://cdn.jsdelivr.net/npm/mermaid@9.4.3/dist/mermaid.min.js";

let mermaidLoaded = false;
let mermaidLoading = false;
const mermaidCallbacks = [];

function loadMermaid(cb) {
  if (mermaidLoaded) { cb(); return; }
  mermaidCallbacks.push(cb);
  if (mermaidLoading) return;
  mermaidLoading = true;
  const script = document.createElement("script");
  script.src = MERMAID_CDN;
  script.onload = () => {
    window.mermaid.initialize({ startOnLoad: false, theme: "default", securityLevel: "loose", flowchart: { useMaxWidth: true, htmlLabels: true } });
    mermaidLoaded = true;
    mermaidCallbacks.forEach((fn) => fn());
    mermaidCallbacks.length = 0;
  };
  document.head.appendChild(script);
}

// ─── Diagramas de Prospección ─────────────────────────────────────────────────

const DIAGRAMA_PROSPECCION_PANORAMA = `flowchart LR
    classDef entrada  fill:#fdf4ff,stroke:#a855f7,color:#6b21a8,font-weight:bold
    classDef caraA    fill:#fffbeb,stroke:#f59e0b,color:#92400e
    classDef caraB    fill:#eff6ff,stroke:#3b82f6,color:#1d4ed8
    classDef salida   fill:#f0fdf4,stroke:#22c55e,color:#166534,font-weight:bold
    classDef descarte fill:#fef2f2,stroke:#f87171,color:#991b1b
    N["➕ NUEVO PROSPECTO\nempresa · origen · contacto"]:::entrada
    subgraph EMBUDO["izquierda → derecha = progreso en la relación"]
        direction LR
        A["⬜ SIN TOCAR\nIdentificado, sin contactar aún"]:::caraA
        B["🟡 ESPERANDO RESPUESTA\nLe escribiste, esperás que conteste\n⚠ Alerta si superan 2 días"]:::caraA
        C["🔵 EN DIÁLOGO\nConversación activa\nCompletás la ficha y registrás hitos"]:::caraB
        A -->|"Primer contacto"| B
        B -->|"Respondió"| C
    end
    N --> A
    C ==>|"Generar solicitud"| CONV
    subgraph CONV["✅ CONVERSIÓN"]
        direction TB
        CLI["🏢 Cliente creado en CRM\nficha · contactos · historial"]:::salida
        SOL["📋 Solicitud de cotización\nestado: pendiente"]:::salida
        CLI --> SOL
    end
    B -->|"Sin respuesta"| FR["❄️ FRÍO"]:::caraA
    FR -->|"Retomar"| B
    C -->|"Se enfrió"| PA["⏸ EN PAUSA"]:::caraA
    PA -->|"Reactivar"| C
    A & B & C & FR & PA -.->|"Descartar"| DESC(["🗑 DESCARTADO\nmotivo registrado"]):::descarte`;

const DIAGRAMA_PROSPECCION_PING_PONG = `flowchart TD
    classDef accion fill:#fffbeb,stroke:#f59e0b,color:#92400e
    classDef sistema fill:#f8fafc,stroke:#94a3b8,color:#334155
    classDef salida fill:#f0fdf4,stroke:#22c55e,color:#166534
    START["🟡 Prospecto en ESPERANDO RESPUESTA"]
    T["📤 Registrar toque\nElegís el canal: mail · LinkedIn · WhatsApp · llamada"]:::accion
    ESPERA["⏳ Esperás la respuesta\nEl sistema cuenta los días automáticamente"]:::sistema
    ALERTA["⚠️ +2 días sin respuesta\nAparece en amarillo en el embudo\ny en Mi semana"]:::sistema
    DEC{"¿Respondió?"}
    OTRO["📤 Nuevo toque\nCambiás de canal o reforzás el mensaje"]:::accion
    START --> T --> ESPERA --> ALERTA --> DEC
    DEC -->|"Sí, respondió"| OK["→ Pasa a EN DIÁLOGO 🔵"]:::salida
    DEC -->|"No, pero vale insistir"| OTRO --> ESPERA
    DEC -->|"No y ya no tiene sentido"| FRIO["→ Pasa a FRÍO ❄️"]`;

const DIAGRAMA_PROSPECCION_HITOS = `flowchart TD
    classDef info fill:#eff6ff,stroke:#3b82f6,color:#1d4ed8
    classDef accion fill:#fffbeb,stroke:#f59e0b,color:#92400e
    classDef resultado fill:#f0fdf4,stroke:#22c55e,color:#166534
    START["🔵 Prospecto en EN DIÁLOGO"]
    FICHA["✎ Completar la ficha del prospecto\n• Con quién hablo\n• Qué les interesa\n• A quién le compran hoy\n• Dónde está la oportunidad"]:::info
    HITO["✱ Registrar hito\npor cada intercambio importante\n• Canal · Contacto\n• Resumen de la conversación\n• Próximo paso acordado"]:::accion
    TIMELINE["📋 Timeline de hitos\nVisible en el detalle del prospecto\nQueda como historial de la relación"]:::info
    CONV["Al convertir:\ntodo el historial migra\nautomáticamente al CRM del cliente"]:::resultado
    START --> FICHA
    START --> HITO --> TIMELINE --> CONV
    FICHA --> CONV`;

// ─── Diagramas de Cotizaciones ───────────────────────────────────────────────

const DIAGRAMA_COTIZACIONES_PANORAMA = `flowchart LR
    classDef pedido  fill:#f0f4ff,stroke:#6366f1,color:#3730a3,font-weight:bold
    classDef interno fill:#fffbeb,stroke:#f59e0b,color:#92400e
    classDef cotiz   fill:#eff6ff,stroke:#3b82f6,color:#1d4ed8
    classDef oc      fill:#f0fdf4,stroke:#22c55e,color:#166534,font-weight:bold
    classDef desc    fill:#fef2f2,stroke:#f87171,color:#991b1b

    SOL["📋 SOLICITUD CREADA\nRecordatorio de que hay algo para cotizar"]:::pedido
    PEN["⏳ PENDIENTE"]:::interno
    FAB["🏭 EN FÁBRICA\nconsulta enviada al proveedor"]:::interno
    FORM["📝 Armar cotización\nítems · precios · moneda"]:::cotiz
    COT["📄 COTIZACIÓN\nenviada al cliente · esperando confirmación"]:::cotiz
    OC["✅ ORDEN DE COMPRA\nentra al kanban de producción"]:::oc
    DIRECTO["➕ Nueva cotización directa\n(sin solicitud previa)"]:::cotiz
    DESC(["✗ RECHAZADA\nmotivo registrado"]):::desc

    SOL --> PEN -->|"Enviar a fábrica"| FAB
    FAB -->|"Proveedor devuelve precios"| FORM
    DIRECTO --> FORM
    FORM ==>|"Guardar"| COT
    COT ==>|"Cliente confirma + PO firmada"| OC
    PEN & FAB & COT -.->|"Rechazar"| DESC`;

const DIAGRAMA_COTIZACIONES_SOLICITUD = `flowchart TD
    classDef accion fill:#fffbeb,stroke:#f59e0b,color:#92400e
    classDef espera fill:#f8fafc,stroke:#94a3b8,color:#334155
    classDef salida fill:#eff6ff,stroke:#3b82f6,color:#1d4ed8

    START["📋 Solicitud PENDIENTE\nrecordatorio de que hay algo para cotizar"]
    FAB["🏭 Enviar a fábrica\nRegistrás: nota · quién · fecha automática"]:::accion
    ESPERA["⏳ Solicitud queda En fábrica\nEsperás respuesta del proveedor"]:::espera
    RESP["📩 Proveedor devuelve precios\npor mail, WhatsApp o llamada"]:::espera
    FORM["📝 Aceptar solicitud\nAbre el formulario de cotización\npre-cargado con los datos"]:::salida

    START --> FAB --> ESPERA --> RESP --> FORM`;

const DIAGRAMA_COTIZACIONES_CONFIRMACION = `flowchart TD
    classDef form   fill:#eff6ff,stroke:#3b82f6,color:#1d4ed8
    classDef accion fill:#fffbeb,stroke:#f59e0b,color:#92400e
    classDef oc     fill:#f0fdf4,stroke:#22c55e,color:#166534,font-weight:bold

    ENTRY["📝 Formulario de cotización\n(desde solicitud aceptada o cotización directa)"]:::form

    subgraph DATOS["Datos que completás"]
        direction TB
        D1["Cliente · Proveedor · Contacto"]:::form
        D2["Ítems: descripción · cantidad · precio"]:::form
        D3["Moneda: ARS o USD\nUSD auto-trae tipo de cambio BNA"]:::form
        D4["Archivos adjuntos\n(OC del cliente, planos, specs)"]:::form
    end

    ENTRY --> DATOS
    DATOS -->|"Guardar"| COT["📄 Cotización creada\nPodés editarla antes de enviarla"]:::form
    COT -->|"La enviás al cliente\n(fuera del sistema)"| ESPERA["📬 Esperás confirmación del cliente"]:::accion
    ESPERA -->|"Cliente confirma\nSubís PO firmada"| OC["✅ Orden de Compra confirmada\nEntra al kanban · se crean registros de producción"]:::oc
    ESPERA -.->|"Cliente rechaza"| DESC["✗ Cotización rechazada"]:::accion`;

// ─── Estructura de tabs ───────────────────────────────────────────────────────
// Para agregar un nuevo proceso: agregar un objeto a este array.
// Para agregar un diagrama dentro de un proceso: agregar un objeto al array "diagramas".

const TABS = [
  {
    key: "prospeccion",
    label: "Prospección",
    diagramas: [
      {
        titulo: "Embudo completo",
        descripcion: "Vista panorámica de los estados y transiciones del proceso de prospección.",
        codigo: DIAGRAMA_PROSPECCION_PANORAMA,
      },
      {
        titulo: "Cadencia de toques (Cara A)",
        descripcion: "La lógica de ping-pong: cómo insistir por distintos canales cuando no hay respuesta.",
        codigo: DIAGRAMA_PROSPECCION_PING_PONG,
      },
      {
        titulo: "Hitos en conversación (Cara B)",
        descripcion: "Cómo registrar y usar los hitos durante la etapa de diálogo activo con el prospecto.",
        codigo: DIAGRAMA_PROSPECCION_HITOS,
      },
    ],
  },
  {
    key: "cotizaciones",
    label: "Cotizaciones",
    diagramas: [
      {
        titulo: "Flujo completo",
        descripcion: "Vista panorámica del proceso de cotización: desde la solicitud hasta la orden de compra confirmada.",
        codigo: DIAGRAMA_COTIZACIONES_PANORAMA,
      },
      {
        titulo: "Gestión de la solicitud",
        descripcion: "Cómo manejar una solicitud de cotización hasta tener los precios del proveedor.",
        codigo: DIAGRAMA_COTIZACIONES_SOLICITUD,
      },
      {
        titulo: "Cotización → Orden de Compra",
        descripcion: "Desde que armás la cotización formal hasta que el cliente confirma y se genera la OC.",
        codigo: DIAGRAMA_COTIZACIONES_CONFIRMACION,
      },
    ],
  },
  // Para agregar más procesos, descomentá y completá:
  // { key: "ordenes", label: "Órdenes", diagramas: [...] },
];

// ─── Componente de renderizado Mermaid ────────────────────────────────────────
const MermaidDiagram = ({ id, code }) => {
  const ref = useRef(null);

  useEffect(() => {
    loadMermaid(() => {
      if (!ref.current) return;
      // Remover elemento previo si existe (mermaid v9 requiere ID único)
      const prev = document.getElementById(`mermaid-${id}`);
      if (prev) prev.remove();
      try {
        window.mermaid.render(`mermaid-${id}`, code, (svg) => {
          if (ref.current) ref.current.innerHTML = svg;
        });
      } catch (e) {
        if (ref.current) {
          ref.current.innerHTML =
            `<p style="color:#dc2626;font-size:13px;padding:12px">Error al renderizar el diagrama</p>`;
        }
      }
    });
  }, [id, code]);

  return <div ref={ref} style={{ overflowX: "auto", textAlign: "center" }} />;
};

// ─── Componente principal ─────────────────────────────────────────────────────
const Procesos = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].key);
  const tab = TABS.find((t) => t.key === activeTab) || TABS[0];

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f7f4f6",
      padding: "28px 20px",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>

        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: "#222" }}>Procesos</h1>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "#888" }}>
            Diagramas de referencia para el equipo
          </p>
        </div>

        {/* Tabs */}
        <div style={{
          display: "flex",
          gap: 0,
          borderBottom: "2px solid #e0d6dc",
          marginBottom: 28,
        }}>
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setActiveTab(t.key)}
              style={{
                padding: "10px 22px",
                background: "none",
                border: "none",
                borderBottom: activeTab === t.key ? "3px solid #9f0059" : "3px solid transparent",
                marginBottom: -2,
                fontSize: 14,
                fontWeight: activeTab === t.key ? 700 : 500,
                color: activeTab === t.key ? "#9f0059" : "#888",
                cursor: "pointer",
                transition: "color 0.15s",
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Cards de diagramas */}
        {tab.diagramas.map((d, i) => (
          <div
            key={i}
            style={{
              background: "#fff",
              borderRadius: 12,
              padding: "24px 28px",
              border: "1.5px solid #f0e6ec",
              boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
              marginBottom: 24,
            }}
          >
            <h2 style={{ margin: "0 0 6px", fontSize: 17, fontWeight: 700, color: "#222" }}>
              {d.titulo}
            </h2>
            <p style={{ margin: "0 0 20px", fontSize: 13, color: "#888" }}>
              {d.descripcion}
            </p>
            <MermaidDiagram id={`${activeTab}-${i}`} code={d.codigo} />
          </div>
        ))}

      </div>
    </div>
  );
};

export default Procesos;
